module.exports = __webpack_public_path__ + "static/hero1_mob-10b72ce3e22da6135e26d0ab3e9a29ff.jpg";